import './AvatarStack-802bdd7c.css';

var classes = {"AvatarStack":"prc-AvatarStack-AvatarStack-N-r3C","AvatarItem":"prc-AvatarStack-AvatarItem-nS1mt","AvatarStackBody":"prc-AvatarStack-AvatarStackBody-mSyoJ"};

export { classes as default };
